import { StyledTextCreator } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P, R, Segments, SharedColors } from "apparatus/library/common";
import { createJack } from "apparatus/library/physics/electric/common";
import { Group, Path, PointText } from "paper";
const switchText = new StyledTextCreator({
    fontFamily: "sans-serif",
    fontSize: 7,
    fillColor: "#ffffff",
});
const markerTexts = new StyledTextCreator({
    fontFamily: "sans-serif",
    fontSize: 8,
    fillColor: "#888",
    justification: "center"
});
export class PowerPack {
    render(appearance) {
        const casing = new Path.Rectangle(R(0, 0, 185, 100), 3.0)
            .withStroke("default")
            .withGradientFill("down", Gradients.box(SharedColors.deviceGrey.color(), { shift: 0.1 }));
        const dial = new Path.Circle(P(0, 0), 20)
            .withStroke("default").withGradientFill("right-down", Gradients.cylinder("#555555".color()));
        const dialGroup = new Group([dial]);
        const dialRange = 270;
        const maxVoltage = 12;
        const minVoltage = 0;
        for (let voltage = minVoltage; voltage <= maxVoltage; voltage++) {
            const angle = ((voltage - minVoltage) / (maxVoltage - minVoltage) - 0.5) * dialRange;
            const marker = new Path.Line(P(0, -24), P(0, -27)).withStroke(1.0, "#888888");
            marker.rotate(angle, P(0, 0));
            dialGroup.addChild(marker);
            const text = markerTexts.create(voltage.toString(), P(0, -32).rotate(angle, P(0, 0)).add(P(0, 3)), voltage == appearance.voltage ? { fontWeight: "bold", fillColor: "#333" } : {});
            dialGroup.addChild(text);
        }
        const currentVoltageMarker = new Path.Line(P(0, -6), P(0, -18)).withStroke("default", "#ccc");
        currentVoltageMarker.rotate(((appearance.voltage - minVoltage) / (maxVoltage - minVoltage) - 0.5) * dialRange, P(0, 0));
        dialGroup.addChild(currentVoltageMarker);
        dialGroup.position = P(73, 55);
        // Connection jacks.
        // NOTE: if adjusting these DON'T FORGET to update snapping as well!.
        const posTopLeft = P(130, 40);
        const posTopRight = P(160, 40);
        const posBottomLeft = P(130, 80);
        const posBottomRight = P(160, 80);
        const posTopLabel = P(145, 25);
        const posBottomLabel = P(145, 65);
        const acJack1 = createJack("yellow");
        const acJack2 = createJack("yellow");
        const dcJack1 = createJack("red");
        const dcJack2 = createJack("black");
        const acLabel = jackLabel("ac");
        const dcLabel = jackLabel("dc");
        if (appearance.ac_position === "top") {
            acJack1.withPosition(posTopRight);
            acJack2.withPosition(posTopLeft);
            acLabel.withPosition(posTopLabel);
            dcLabel.withPosition(posBottomLabel);
            if (appearance.dc_terminals === "+-") {
                dcJack1.withPosition(posBottomLeft);
                dcJack2.withPosition(posBottomRight);
            }
            else {
                dcJack1.withPosition(posBottomRight);
                dcJack2.withPosition(posBottomLeft);
            }
        }
        else {
            // Swap ac jacks and dc jacks
            acJack1.withPosition(posBottomRight);
            acJack2.withPosition(posBottomLeft);
            acLabel.withPosition(posBottomLabel);
            dcLabel.withPosition(posTopLabel);
            if (appearance.dc_terminals === "+-") {
                dcJack1.withPosition(posTopLeft);
                dcJack2.withPosition(posTopRight);
            }
            else {
                dcJack1.withPosition(posTopRight);
                dcJack2.withPosition(posTopLeft);
            }
        }
        // Switch.
        const switchButton = new Path.Rectangle(R(15, 20, 13, 30), 2.0)
            .withStroke(3.0, "#222222")
            .withGradientFill("down", [["#333333", 0.0], ["#555555", 0.45], ["#888888", 0.55], ["#999999", 1.0]]);
        const oText = switchText.create("O", P(22, 29), { fillColor: "#999999" });
        const iText = switchText.create("I", P(22, 44));
        const graphic = new Group([
            casing, dialGroup, acJack1, acJack2, dcJack1, dcJack2, acLabel, dcLabel, switchButton,
            oText, iText,
        ]);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            snapping: [
                casing.placeable(),
                { type: "wireport", at: P(130, 40) },
                { type: "wireport", at: P(160, 40) },
                { type: "wireport", at: P(130, 80) },
                { type: "wireport", at: P(160, 80) },
            ]
        };
    }
}
PowerPack.properties = {
    label: "Power pack",
    defaultAppearance: {
        voltage: 8,
        dc_terminals: "-+",
        ac_position: "top",
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "voltage", label: "Voltage",
            min: 0, max: 12
        },
        {
            spec: "header", header: "Terminals", icon: "plug"
        },
        {
            spec: "toggle-buttons",
            key: "dc_terminals",
            label: "DC",
            size: "text",
            options: [
                { value: "-+", label: "- +" },
                { value: "+-", label: "+ -" },
            ]
        },
        {
            spec: "toggle-buttons",
            key: "ac_position",
            label: "AC Position",
            size: "text",
            options: [
                { value: "top", label: "Top" },
                { value: "bottom", label: "Bottom" },
            ]
        }
    ],
};
const jackLabel = (text) => new Group([
    new PointText({
        point: P(0, 4),
        content: text.toUpperCase(),
        fillColor: "#888",
        fontFamiy: "sans-serif",
        fontSize: 9,
        justification: "center",
    }),
    new Path(Segments([[-15, 5]], [[-15, 0]], [[-9, 0]])).withStroke(1.0, "#888"),
    new Path(Segments([[15, 5]], [[15, 0]], [[9, 0]])).withStroke(1.0, "#888"),
]);
